import { getController, postController } from '@/controllers/request';
import router from '@/router/index';
import { errorMsg, callNotifications } from '@/utils/mixins';
export default {
  namespaced: true,
  state: {
    auth: true,
    loading: false,
    offerStatus: {},
    isSessionExists: false,
    isSessionLost: false,
    showRestorePasswordButton: false,
    user: {},
    userId: '',
    umamiAttr: {}
  },
  mixins: [errorMsg, callNotifications],
  mutations: {
    removeAuth(state) {
      state.auth = false;
      state.offerStatus = {};
      state.isSessionExists = false;
      state.isSessionLost = false;
      state.user = {};
      localStorage.setItem('auth', false);
      router.push('/login');
    },
    setOfferStatus(state, status) {
      state.offerStatus = status;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setAuth(state) {
      state.auth = true;
      localStorage.setItem('auth', true);
    },
    setExistSession(state, isSessionExists) {
      state.isSessionExists = isSessionExists;
    },
    setIsSessionLost(state, isLost) {
      state.isSessionLost = isLost;
    },
    setRestorePasswordButton(state, value) {
      state.showRestorePasswordButton = value;
    },
    setUmamiAttr(state, attr) {
      state.umamiAttr = attr;
      const elem = document.getElementById('umami');
      for (let [key, value] of Object.entries(state.umamiAttr)) {
        elem.setAttribute(key, value);
      }
    }
  },
  actions: {
    async getUmamiAttr({ commit }) {
      try {
        const { data } = await getController({
          url: '?entryPoint=get_analytics_metadata'
        });
        commit('setUmamiAttr', data?.meta?.engine_data || {});
      } catch (error) {
        console.error(error);
      }
    },
    async checkAuth() {
      try {
        await getController({
          params: {
            entryPoint: 'check_session_auth'
          }
        });
        return true;
      } catch (error) {
        console.error(error);
        return false;
      }
    },
    async getOfferStatus({ commit }) {
      try {
        const params = {
          entryPoint: 'check_offer_status'
        };
        const { data } = await getController({ params });
        commit('setOfferStatus', data?.offer_status);
        commit(
          'setRestorePasswordButton',
          data?.can_password_change?.show || false
        );
      } catch (error) {
        console.error(error);
      }
    },
    async exitUser({ commit }) {
      try {
        await getController({
          params: {
            module: 'Alerts',
            action: 'get',
            to_pdf: 1
          }
        });

        localStorage.setItem('rightPanelMode', null);

        commit(
          'rightPanel/setParam',
          {
            name: 'panelMode',
            val: null
          },
          { root: true }
        );

        commit('removeAuth');
      } catch (error) {
        return false;
      }
    },

    async checkRestorePassword(ctx, { user_email }) {
      try {
        const options = new FormData();

        options.append('entryPoint', 'GeneratePassword');
        options.append('link', 1);
        options.append('user_email', user_email);

        const { data } = await postController({
          options,
          params: {
            header: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }
        });

        if (data.status == 'success') {
          errorMsg.methods.showNotification({
            offset: 100,
            showClose: true,
            duration: 25000,
            message:
              data?.text ||
              'На указанную почту отправлено письмо со ссылкой для восстановления пароля',
            type: 'success'
          });
        } else {
          errorMsg.methods.showNotification({
            offset: 100,
            showClose: true,
            duration: 25000,
            message:
              data?.text ||
              'Ошибка при отправке письма для восстановления пароля',
            type: 'error'
          });
        }

        return true;
      } catch (error) {
        return false;
      }
    },
    async setNewPassword({ dispatch }, { guid, user_name, new_password }) {
      try {
        const options = new FormData();

        options.append('entryPoint', 'Changenewpassword');
        options.append('guid', guid);
        options.append('user_name', user_name);
        options.append('new_password', new_password);
        options.append('login', 1);

        const { data } = await postController({
          options,
          params: {
            header: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }
        });

        if (data.status === 'ok') {
          errorMsg.methods.showNotification({
            offset: 100,
            showClose: true,
            duration: 25000,
            message: 'Новый пароль успешно установлен',
            type: 'success'
          });
          await dispatch('authenticate', {
            login: user_name,
            password: new_password,
            force: false
          });
          router.push('/');
        } else {
          errorMsg.methods.showMultiTextNotification({
            title: data?.error?.error_title || '',
            offset: 100,
            showClose: true,
            duration: 10000,
            message: data?.error?.error_text?.error?.error_text || 'Ошибка',
            messageArray: [],
            type: 'error'
          });
        }
      } catch (error) {
        console.error(error);
        return false;
      }
    },
    async authenticate(
      { commit },
      { login, password, force = false, ...args }
    ) {
      commit('setLoading', true);
      try {
        // code используется для авторизации по почте
        // если его нет то code не отправляем
        const code = router.currentRoute?.query?.code;

        const formData = new FormData();
        const params = {
          module: 'Users',
          action: 'Authenticate',
          user_name: login,
          code,
          force: force ? true : code ? true : false,
          username_password: password,
          ...args
        };

        for (let key in params) {
          formData.set(key, params[key]);
        }

        const { data } = await postController({
          options: formData
        });

        if (data.status === 'ok') {
          commit('setAuth');
          callNotifications.methods.updateNotifications(true);
        }

        return {
          status: true,
          firstLogin: data?.first_login || false
        };
      } catch (error) {
        if (error.response.data.code === 'SESSION_EXISTS') {
          commit('setExistSession', true);
          return true;
        } else if (error.response.data.code === 'SESSION_LOST') {
          commit('setIsSessionLost', true);
          return true;
        } else if (
          error.response.data.code === 'UNAUTHENTICATED' &&
          error.response.data?.message
        ) {
          errorMsg.methods.showNotification({
            offset: 100,
            showClose: true,
            duration: 25000,
            message: error.response.data.message,
            type: 'error'
          });
        } else {
          console.error(error);
        }
        return false;
      } finally {
        commit('setLoading', false);
      }
    }
  }
};
